import axios from 'axios'

type LoadPreSignUrlInput = {
  file: File
  assetId: number
}

export type LoadPreSignUrlOutput = {
  url: string
  dataUrl: string
  dataThumbUrl: string
}

type UploadToS3Input = {
  preSignUrl: string
  file: File
}

export type PublishAssetOutput = {
  url: string
  thumb: {
    url: string
  }
  warning: string
  updatedAt: string
  fileSize: number
}

export const CommonContentRepository = {
  loadPreSignUrl: async (input: LoadPreSignUrlInput): Promise<LoadPreSignUrlOutput> => {
    const payload = {
      tableName: 'assets', // 固定値
      columnName: 'data', // 固定値
      recordId: input.assetId,
      fileName: input.file.name,
      mimeType: input.file.type,
      processType: 'API', // 固定値
    }
    const response = await axios.post(
      `${process.env.RoovWorksUrl}/api/v3/new/uploads/presign_url`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: process.env.RoovMicroservicesApiKey,
        },
      }
    )

    return response.data
  },

  uploadToS3: async (input: UploadToS3Input): Promise<void> => {
    await axios.put(input.preSignUrl, input.file, {
      headers: {
        'Content-Type': input.file.type,
      },
    })
  },

  publishAsset: async (dataUrl: string): Promise<PublishAssetOutput> => {
    const response = await axios.post(
      `${process.env.RoovWorksUrl}/api/v3/new/uploads/publish`,
      { url: dataUrl },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: process.env.RoovMicroservicesApiKey,
        },
      }
    )

    return response.data
  },
} as const
